<template>
  <div id="app" :class="colors[currentColor]" @wheel="scroll">
    <in-view ref="top"></in-view>
    <div class="main">
      <div id="passwd-modal-cnt" @click="hidePassword($event);"></div>
      <div id="passwd-modal">
        <div id="passwd-close"><a href="#" id="passwd-x" @click="hidePassword($event);">X</a></div>
        <div id="passwd-text">ENTER PASSWORD</div>
        <form @submit.prevent="">
        <input v-on:keydown.13="checkPassword($event);" id="passwd" type="password">
        <br>
        <a href="#" id="passwd-button" @click="checkPassword($event);">ENTER</a>
        </form>
      </div>
      <div class="navbar center-block text-center" v-bind:class="{ scrollup: isScrollUp }">
        <div class="logo">
          <div :class="startHome ? 'logo-bar large' : 'logo-bar'"></div>
          <div :class="startHome ? 'start logo-background' : 'logo-background'"></div>
          <div :class="startHome ? 'start text' : 'text'">CREATIVE DIRECTION, UX DESIGN</div>
        </div>
        <div class="center-block text-center">
          <a @click="changeSlide(0, true)" class="btn btn-op" :class="slides[0].active ? 'active' : ''">UX</a>
          <a @click="changeSlide(1, true)" class="btn btn-op" :class="slides[1].active ? 'active' : ''">Creative
            Direction</a>
          <a @click="changeSlide(2, true)" class="btn btn-op" :class="slides[2].active ? 'active' : ''">Wireframes</a>
        </div>
      </div>
      
      <div class="center-block text-center case-studies" v-bind:class="{ scrollup: isScrollUp }">
        <a href="#" target="_blank" class="btn btn-op" @click="showPassword($event);">VIEW CASE STUDIES</a>
      </div>
      
      <div class="header" v-show="!smallNav">
        <div class="col-xs-12 content">
          <div class="center-block text-center">
            <h2 class="center-block text-center">OCTAVIAN<br/>PAVELESCU</h2>
          </div>
          <br/>
          <div class="center-block text-center">
            <h1 class="center-block text-center">Portfolio</h1>
          </div>
          <div class="center-block descriptionTitle">
            <h4 class="center-block">Creative Direction, User Experience, Interaction Design</h4>
            <h6 class="center-block">UX, UI, CD</h6>
          </div>
          <div class="description">
            Creative Director specializing in User Experience with an academic background in Media/Design and 8
            years of
            interactive Design experience.
          </div>
        </div>
      </div>
      <div v-show="slides[0].active" id="home">
        <div class="slideshow">
          <slide-show v-on:sc="slideChanged" :init="slides[0].activeSlide" :small="smallNav" :status="slides[0].active">
            <slide slot="item" :init="true">
              <h1>01 – Ficksr – web</h1>
              <h2>UX, UI, CD</h2>
              <p>
                Work includes UX/UI, Conducting research, Creative Direction, leading Design team and collaborating
                closely with Development team on the full range of materials for the application's website, CMS, mobile
                app.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX1.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX2.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX3.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX4.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX5.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX6.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX7.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX8.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX9.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX10.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX11.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX12.png" alt="Ficksr">
              </div>
            </slide>
            <slide slot="item">
              <h1>02 – Ficksr – app</h1>
              <h2>UX, UI, CD</h2>
              <p>
                Work includes UX/UI, Conducting research, Creative Direction, leading Design team and collaborating
                closely with Development team on the full range of materials for the application's website, CMS, mobile
                app.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX13.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX14.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX15.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX16.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX17.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX18.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX19.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX20.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX21.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX22.jpg" alt="Ficksr">
              </div>
            </slide>
            <slide slot="item">
              <h1>03 – ShipChat – web</h1>
              <h2>UX, UI, CD</h2>
              <p>
                Led a team of UX and visual designers, turning a logistics, shipping and
                transport service into a conversational chatbot system targeting millennials. Conducted competitive
                research, user surveys and interviews. Advocated UX patterns and a visual design approach that
                emphatically differentiates the product.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX23.png" alt="Ficksr">
              </div>
              <!--
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX24.png" alt="Ficksr">
              </div>
              -->
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX25.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX26.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX27.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX28.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX29.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX30.png" alt="Ficksr">
              </div>
            </slide>
            <slide slot="item">
              <h1>04 – ShipChat – app</h1>
              <h2>UX, UI, CD</h2>
              <p>
                Led a team of UX and visual designers, turning a logistics, shipping and transport service into a
                chatbot system targeting millennials. Conducted competitive research, user surveys and interviews.
                Advocated UX patterns and a visual design approach that emphatically differentiates the product.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX30.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/Ux30a.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX30b.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX30c.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX31.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX32.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX34.png" alt="Ficksr">
              </div>
            </slide>
            <slide slot="item">
              <h1>05 – LaughOn</h1>
              <h2>UX, UI, CD</h2>
              <p>
                Led the design team in turning a crowdsourced comedy platform into a live, interactive experience.
                Conducted research and usability tests and implemented frequent design iterations in an Agile
                environment.
              </p>
              <div class="text-center image">
                <div class="text-center image">
                  <img class="img-responsive center-block" src="./assets/UX35.png" alt="Ficksr">
                </div>
                <div class="text-center image">
                  <img class="img-responsive center-block" src="./assets/UX36.png" alt="Ficksr">
                </div>
                <div class="text-center image">
                  <img class="img-responsive center-block" src="./assets/UX37.png" alt="Ficksr">
                </div>
                <div class="text-center image">
                  <img class="img-responsive center-block" src="./assets/UX38.png" alt="Ficksr">
                </div>
                <div class="text-center image">
                  <img class="img-responsive center-block" src="./assets/UX39.png" alt="Ficksr">
                </div>
                <div class="text-center image">
                  <img class="img-responsive center-block" src="./assets/UX40.png" alt="Ficksr">
                </div>
                <div class="text-center image">
                  <img class="img-responsive center-block" src="./assets/UX41.png" alt="Ficksr">
                </div>
              </div>
            </slide>
            <slide slot="item">
              <h1>06 – VirtualDossier</h1>
              <h2>Interaction Design, CD</h2>
              <p>
                Worked with Design team on reporting & analytics tools and workflows. Worked with Analytics team to
                understand & analyze large amounts of data, and to design insight-generating tools and visualizations.
                Outlined a modular approach to designing and testing data visualization tools and user interactions.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX42.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX43.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX44.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX45.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX46.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX47.png" alt="Ficksr">
              </div>
            </slide>
            <slide slot="item">
              <h1>07 – LawTrades, Tomo</h1>
              <h2>UX, UI</h2>
              <p>
                Led creative team in UX research and planning, detailed wireframing and
                prototyping. Lead the visual design of user interfaces, information architecture and
                interaction flows to create user-centric design solutions.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX48.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/UX49.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX50.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/UX51.png" alt="Ficksr">
              </div>
            </slide>
          </slide-show>
        </div>
      </div>
      <div v-show="slides[1].active" id="wireframe">
        <div class="slideshow">
          <slide-show v-on:sc="slideChanged" :init="slides[1].activeSlide" :small="smallNav" :status="slides[1].active">
            <slide slot="item" :init="true">
              <h1>01 – Ficksr – web</h1>
              <h2>UX, UI, CD</h2>
              <p>
                Work includes UX/UI, Conducting research, Creative Direction, leading Design team and collaborating
                closely with Development team on the full range of materials for the application's website, CMS, mobile
                app.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection1.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection2.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection3.png" alt="Ficksr">
              </div>
            </slide>
            <slide slot="item">
              <h1>02 – Ficksr – app</h1>
              <h2>UX, UI, CD</h2>
              <p>
                Work includes UX/UI, Conducting research, Creative Direction, leading Design team and collaborating
                closely with Development team on the full range of materials for the application's website, CMS, mobile
                app.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection4.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection5.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection6.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection7.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection8.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection9.png" alt="Ficksr">
              </div>
            </slide>
            <slide slot="item">
              <h1>03 – ShipChat – web</h1>
              <h2>UX, UI, CD</h2>
              <p>
                Led a team of UX and visual designers, turning a logistics, shipping and transport service into a
                conversational chatbot system targeting millennials. Conducted competitive research, user surveys and
                interviews. Advocated UX patterns and a visual design approach that emphatically differentiates the
                product.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection10.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection11.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection12.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection13.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection14.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection15.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection16.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection17.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection18.png" alt="Ficksr">
              </div>
            </slide>
            <slide slot="item">
              <h1>04 – ShipChat – app</h1>
              <h2>UX, UI, CD</h2>
              <p>
                Led a team of UX and visual designers, turning a logistics, shipping and transport service into a custom
                chatbot system targeting millennials. Conducted competitive research, user surveys and interviews.
                Advocated UX patterns and a visual design approach that emphatically differentiates the product.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection19.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection20.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection21.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection22.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection23.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection24.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection25.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection26.png" alt="Ficksr">
              </div>
              <div class="text-center image-simple-space">
                <img class="img-responsive center-block" src="./assets/CreativeDirection27.png" alt="Ficksr">
              </div>
              <div class="text-center image-simple-space">
                <img class="img-responsive center-block" src="./assets/CreativeDirection28.png" alt="Ficksr">
              </div>
            </slide>
            <slide slot="item">
              <h1>05 – Further samples/Iterations</h1>
              <h2>UX, UI</h2>
              <p>
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection29.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection30.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/CreativeDirection31.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection32.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection33.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection34.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection35.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection36.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection37.jpg" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block" src="./assets/CreativeDirection38.jpg" alt="Ficksr">
              </div>
            </slide>
          </slide-show>
        </div>
      </div>
      <div v-show="slides[2].active" id="mobile">
        <div class="slideshow">
          <slide-show v-on:sc="slideChanged" :init="slides[2].activeSlide" :small="smallNav" :status="slides[2].active">
            <slide slot="item" :init="true">
              <h1>01 – 1800Flowers</h1>
              <h2>UX</h2>
              <p>Redesign of email settings and account preferences for the e-commerce platform and its partner
                companies. Fast-paced wireframe iterations within Agile environment. full-image
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes1.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes2.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes3.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes4.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes5.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes6.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes7.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes8.png" alt="Ficksr">
              </div>

            </slide>
            <slide slot="item">
              <h1>02 – DiMassimo Goldstein</h1>
              <h2>UX</h2>
              <p>
                Translated user interviews and usability survey results into an intuitive user-centered
                experience in line with marketing goals. Participation in discovery sessions with stakeholders to define features and interaction and produce UX deliverables.
              </p>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes9.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes11.png" alt="Ficksr">
              </div>
            </slide>
            <slide slot="item">
              <h1>03 – Further samples/Iterations</h1>
              <h2>UX</h2>
              <p>UX, Wireframing</p>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes12.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes13.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes14.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes15.png" alt="Ficksr">
              </div>
              <div class="text-center image">
                <img class="img-responsive center-block full-image" src="./assets/Wireframes16.png" alt="Ficksr">
              </div>
            </slide>
          </slide-show>
        </div>
      </div>
      <in-view ref="bottom"></in-view>
    </div>
  </div>
</template>

<script>
  import Hammer from 'hammerjs'
  import Vue from 'vue'
  import SlideShow from './SlideShow.vue'
  import Slide from './Slide.vue'

  let panTimeout = 0
  Array.prototype.unique = function () {
    let o = {}, i, l = this.length, r = []
    for (i = 0; i < l; i += 1) o[this[i]] = this[i]
    for (i in o) r.push(o[i])
    return r
  }
  import inViewport from 'vue-in-viewport-mixin'

  const InView = Vue.component('InView', {
    // this does work, because we are in the right scope
    template: '<div class="col-xs-12 col-md-12"></div>',
    mixins: [inViewport]
  })

  export default {
    name: 'app',
    components: {SlideShow, Slide, InView},
    data () {
      return {
        colors: ['brown', 'yellow', 'white'],
        currentColor: 0,
        samples: 3,
        throttle: 3,
        counter: 0,
        direction: 0,
        navChangePosition: 280,
        scrollPosition: 0,
        samplePostion: [],
        slides: [
          {
            active: true,
            activeSlide: 0
          },
          {
            active: false,
            activeSlide: 0
          },
          {
            active: false,
            activeSlide: 0
          }
        ],
        startHome: true,
        smallNav: false,
        isScrollUp: false,
        change: false
      }
    },
    mounted () {
      const vm = this
      window.addEventListener('scroll', this.getScrollPosition)
      let mc = new Hammer.Manager(this.$el, {
        touchAction: 'auto',
        recognizers: [
          [Hammer.Pan, {direction: Hammer.DIRECTION_VERTICAL, threshold: 100}],
        ]
      })

      mc.on('pan', function (e) {
        if (vm.activeSlideIndex === 0 && vm.scrollPosition === 0) {
          vm.change = false
          vm.samplePostion = []
          vm.smallNav = false
          vm.currentColor = 0
        }
        if (vm.$refs.top.inViewport.now && vm.activeSlideIndex > 0 && vm.slides[vm.activeSlideIndex].activeSlide === 0) {
          clearTimeout(panTimeout)
          panTimeout = setTimeout(() => {
            //vm.changeSlide(vm.activeSlideIndex - 1, false, 999999, true, true);
            vm.changeSlide(this.activeSlideIndex - 1, false, 0, false);  //aici1
          }, 50)
        }

        clearTimeout(panTimeout)
        panTimeout = setTimeout(() => {
          if (vm.$refs.bottom.inViewport.now && vm.activeSlideIndex < 2 && vm.slides[vm.activeSlideIndex].activeSlide > 0) {
            //vm.changeSlide(vm.activeSlideIndex + 1, false, false, true);
            vm.changeSlide(this.activeSlideIndex + 1, false, 0, false)
          }
        }, 50)
      })
      this.smallNav = window.window.pageYOffset > this.navChangePosition
      setTimeout(() => {
        this.startHome = false
      }, 1000)

    },
    methods: {
      checkPassword(ev) {
        ev.preventDefault();
        var pass = document.getElementById('passwd').value;
        if (pass != 'portfolioview') {
          alert('The password is wrong. Please try again.');
        } else {
          var url = 'http://www.octavianux.com/pdf/case-studies.pdf';    
          window.open(url);
          //window.location = url;
        }        
      },
      hidePassword(ev) {
        ev.preventDefault();
        document.getElementById('passwd-modal-cnt').style.display = 'none';
        document.getElementById('passwd-modal').style.display = 'none';
      },
      showPassword(ev) {
        ev.preventDefault();
        document.getElementById('passwd-modal-cnt').style.display = 'block';
        document.getElementById('passwd-modal').style.display = 'block';     
      },
      scroll (pan = false) {
        if (this.$refs.top.inViewport.now || this.$refs.bottom.inViewport.now) {
          this.counter++
        }
        if (pan) {
          this.threshold = 1
          this.samples = 2
        } else {
          this.threshold = 3
          this.samples = 3
        }
      },
      getScrollPosition () {
        this.scrollPosition = window.pageYOffset;
        
        if (typeof window.c_scroll == 'undefined') {
        
          window.c_scroll = this.scrollPosition;
        
        } else {
        
          if (this.scrollPosition <  window.c_scroll) {
          
            this.isScrollUp = true;
            window.c_scroll = this.scrollPosition; //aici
          
          } else {
          
            this.isScrollUp = false;
            window.c_scroll = this.scrollPosition;
          
          }
        
        }
        
      },
      changeColor () {
        if (this.currentColor < this.colors.length - 1) {
          this.currentColor++
        } else {
          this.currentColor = 0
        }
      },
      changeSlide (slide, reset = false, scrollPostion = false, smallNav = false, maxSlide = false) {
        
        //console.log(slide);
        //aici1
        for (let i = 0; i < this.slides.length; i++) {
          this.slides[i].active = (slide === i)
        }
        if (!smallNav) {
          this.currentColor = 0
        }
        if (maxSlide) {
          this.slides[slide].activeSlide = 10
        }

        if (reset) {
          this.slides[slide].activeSlide = -1
        }

        this.smallNav = smallNav
        this.resetChange()

        setTimeout(() => {
          scrollTo(0, scrollPostion)
        }, 10)
      },
      slideChanged (e) {
        if (this.smallNav) {
          if (this.slides[this.activeSlideIndex].activeSlide !== e.activeSlide) {
            this.changeColor()
          }
        }
        this.slides[this.activeSlideIndex].activeSlide = e.activeSlide

      },
      resetChange () {
        this.change = false
        this.samplePostion = []
      }
    },
    computed: {
      activeSlideIndex () {
        return this.slides.findIndex(item => {
          return item.active
        })
      }
    },
    watch: {
      counter (counter) {
        if (this.smallNav) {
          this.samplePostion.length === this.samples && this.samplePostion.unique().length === 1
            ? this.change = true
            : this.samplePostion.length < this.samples
              ? this.samplePostion.push(this.scrollPosition)
              : this.samplePostion = []

          if (this.change && this.activeSlideIndex === 2 && this.scrollPosition !== 0) {
            this.change = false
            this.samplePostion = []
          }
          if (this.change && this.activeSlideIndex === 0 && this.scrollPosition === 0) {
            this.change = false
            this.samplePostion = []
            this.smallNav = false
            this.currentColor = 0
          }
          if (this.change && this.$refs.bottom.inViewport.now && this.activeSlideIndex < 2 && !this.isScrollUp) { // la scroll down
            //this.changeSlide(this.activeSlideIndex + 1, false, false, true)
            this.changeSlide(this.activeSlideIndex + 1, false, 0, false)
            //aici1
            this.resetChange()
          }
          if (this.change && this.$refs.top.inViewport.now && this.activeSlideIndex > 0 && this.isScrollUp) { // la scroll up
            //this.changeSlide(this.activeSlideIndex - 1, false, 999999, true, true)
            this.changeSlide(this.activeSlideIndex - 1, false, 0, false)
            this.resetChange()
          }
        }
        if (counter === this.throttle) {
          this.counter = 0
        }
      },
      scrollPosition (scrollPosition) {
        if (scrollPosition > this.navChangePosition) {
          this.smallNav = true; //aici
        }
      }
    }
  }
</script>

<style>
  body {
    overflow: auto;
  }

  @font-face {
    font-family: Ailerons;
    src: url("assets/fonts/ailerons.woff");
  }

  @font-face {
    font-family: Moon;
    src: url("assets/fonts/moonl.woff");
  }

  @font-face {
    font-family: MoonBold;
    src: url("assets/fonts/moonb.woff");
  }

  #app {
    transition: background 0.5s linear;
  }

  .logo {
    font-family: Ailerons;
    height: 20px;
  }

  .logo .logo-bar {
    transition: all .5s linear;
    background-color: #ffff00;
    height: 20px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: 0;
  }

  .logo .logo-bar.large {
    width: 100%;
  }

  .logo .logo-background {
    top: -20px;
    background-color: #ffff00;
    height: 20px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: 275px;
    transition: all .5s linear;
  }

  .logo .text {
    color: #000;
    position: relative;
    top: -40px;
    font-size: 16px;
    transition: all .5s linear;
  }

  .logo .start.logo-background {
    background-color: #000;
  }

  .logo .start.text {
    color: #fff;
  }

  .white .logo .logo-background, .yellow .logo .logo-background {
    background-color: #000;
  }

  .white .logo .text {
    color: #fff;
  }

  .yellow .logo .text {
    color: #ffff00;
  }

  .brown {
    background-color: #1a100f;
  }

  .yellow {
    background-color: #ffff00;
  }

  .white {
    background-color: #fcfff5;
  }

  h1 {
    color: #d07075;
    font-size: 50px;
    margin-top: 14px;
    font-family: Ailerons;
  }

  h2 {
    color: #d07075;
    font-size: 35px;
    line-height: 42px;
    font-family: Ailerons;
  }

  h3 {
    color: #d07075;
    font-size: 35pt;
    font-family: Ailerons;
  }

  h4 {
    color: #d07075;
    font-size: 14pt;
    font-family: MoonBold;
  }

  h6 {
    color: #d07075;
    font-family: Moon;
  }

  .header {
    min-height: 374px;
    display: block!important;
  }

  .logo {
    margin-top: -1px;
  }

  .btn {
    width: 100px;
    height: 32px;
    margin-top: 0px;
    margin-left: -5px;
    border-radius: 0;
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0) !important;
    box-shadow: inset 0 0 0 rgba(0, 0, 0, 0) !important;
    color: #1a100f;
    font-size: 9px;
    text-align: center;
    padding-left: 0;
    padding-right: 0;
    padding-top: 8px;
    font-family: MoonBold;
    border: 1px #1a100f solid;
  }

  .btn-op.active, .white .btn-op.active {
    background-color: #d07075;
  }

  .white .btn-op.active {
    color: #fcfff5;
  }

  .yellow .btn-op.active {
    background-color: #d07075;
    color: #ffff00;
  }

  .white .btn-op {
    background-color: #fcfff5;
  }

  .btn-op {
    text-transform: uppercase;
    background-color: #ffff00;
    transition: all 0.3s ease
  }

  .descriptionTitle {
    margin-left: auto;
    margin-right: auto;
    width: 288px;
    margin-top: -6px;
  }

  .description {
    font-family: Moon;
    margin-left: auto;
    margin-right: auto;
    width: 365px;
    text-transform: uppercase;
    text-align: center;
    font-size: 9px;
    color: #d07075;
    padding-top: 18px;
    line-height: 10px;
    letter-spacing: 0.9px;
    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;
  }

  .content {
    padding-top: 25px;
  }

  @media (max-width: 412px) {
    .description {
      width: 100%;
    }

    .header {
      min-height: 100px;
    }
    h1 {
      margin-top: -10px;
      margin-bottom: 20px;
    }

    h2 {
      margin-top: 8px;
      margin-bottom: 0;
    }

    h3 {
    }

    h4 {
    }

    h6 {
    }
  }

  .image-simple-space {
    margin-bottom: 60px;
  }

  .image {
    margin-bottom: 60px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
  {
    opacity: 0
  }

  .full-image {
    width: 100% !important;
  }
  
  .navbar {
    /*
    position: fixed;
    z-index: 9999;
    left: 0;
    right: 0;
    */
  }
  
  .case-studies {
    margin-top: 10px;
    position: sticky;
    top: 0px;
    z-index: 99999;
  }
  
  .case-studies a {
    font-size: 20px;
    width: auto;
    padding: 10px 80px;
    display: block;
    font-weight: bold;
    height: auto;
    display: inline-block;
  }
  
  @media (max-width: 370px) {
    .case-studies a {
      padding: 10px 50px;
    }
  }
  
  #passwd-modal-cnt {
    position: fixed;
    background: black;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    z-index: 99999;
  }
  
  #passwd-modal {
    position: fixed;
    left: 50%;
    margin-left: -285px;
    width: 570px;
    text-align: center;
    background-color: #f9ff0d;
    height: 310px;
    z-index: 999999;
    opacity: 1;
    top: 100px;
    padding: 20px;
    font-family: MoonBold;
    font-weight: 700;
  }

  #passwd-close {
    text-align: right;
    font-family: MoonBold;
    font-weight: 700;
  }
  
  #passwd-button {
    font-family: MoonBold;
    font-weight: 700;
    font-size: 15px;
    color: #f9ff0d;
    background-color: black;
    padding: 10px 20px;
    border: 1px solid #cc7678;
    text-decoration: none;
  }
  
  #passwd-text {
    margin: 10px 0 40px 0;
    font-size: 25px;
  }
  
  #passwd {
    margin-bottom: 60px;
    border: 1px solid #cc7678;
    border-radius: 0;
    padding: 5px;
    font-size: 20px;
    width: 350px;
  }
  
  #passwd-x {
    font-family: MoonBold;
    font-weight: 700;
    font-size: 20px;
    color: black;
    text-decoration: none;
  }
  
  #passwd-modal-cnt, #passwd-modal {
    display: none;
  }
  
  .smallNav {
    display: none;
  }
  
  .navbar.scrollup {
    position: sticky;
    top: 0;
    z-index: 999999;
  }
  
  .case-studies.scrollup {
    top: 75px;
  }
  
  @media (max-width: 700px) {
  
    #passwd-modal {
      margin-left: -150px;
      width: 300px;
      height: 270px;
    }
    
    #passwd {
      width: 200px;
      margin-bottom: 40px;
    }
    
    #passwd-text {
      margin: 10px 0 20px 0;
    }
  
  }

</style>



// WEBPACK FOOTER //
// App.vue?6341d2fd